import { render, staticRenderFns } from "./classList.vue?vue&type=template&id=788652da&scoped=true"
import script from "./classList.vue?vue&type=script&lang=js"
export * from "./classList.vue?vue&type=script&lang=js"
import style0 from "./classList.vue?vue&type=style&index=0&id=788652da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788652da",
  null
  
)

export default component.exports